var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { pxToRem } from "../../utils";
export default styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", " {\n    display: block;\n    position: relative;\n\n    ", "\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.cssPrefix;
}, function (_ref2) {
  var $showCurrencySymbol = _ref2.$showCurrencySymbol;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      ", "\n    "])), $showCurrencySymbol && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        & input {\n          padding-left: ", "rem;\n        }\n      "])), pxToRem(30)));
});
export var StyledCurrencyFieldSymbol = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", " {\n    align-items: center;\n    bottom: 0;\n    display: flex;\n    left: ", ";\n    position: absolute;\n    top: 0;\n  }\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.cssPrefix;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacing_04;
});